import React, { useState, useEffect } from "react";
import { Route, Routes, useLocation, useParams } from "react-router";
import Navbar from "./Navbar";
import Home from "./Home";
import Gallery from "./Gallery";
import Agenda from "./Agenda";
import CheckIn from "./CheckIn";
import Registration from "./Registration";
import About from "./About";
import Contact from "./Contact";
import Speakers from "./Speakers";
import Footer from "./Footer";
import SignIn from "./Signin";
import Feedback from "./Feedback";
import ProtectedWrapper from "./ProtectedWrapper";

function EventLayout() {
  const { event_slug } = useParams();
  const [events, setEvents] = useState([]);

  useEffect(() => {
    if (!event_slug) return;

    fetch(`/api/events/${event_slug}/`)
      .then((res) => res.json())
      .then(setEvents);
  }, [event_slug]);

  useEffect(() => {
    if (!events?.name) return;

    document.title = `${events.name}`;
  }, [events?.name]);

  const location = useLocation();

  const hideFooter =
    location.pathname === "registration" || location.pathname.includes("signin") ||
    location.pathname.includes("checkIn");

  return (
    <>
      <Navbar event={events} />
      <Routes>
        <Route index element={<Home event={events} />} />
        <Route path="registration" element={<Registration event={events} />} />
        <Route path="about" element={<About event={events} />} />
        <Route
          path="agenda"
          element={
            <ProtectedWrapper>
              <Agenda event={events} />
            </ProtectedWrapper>
          }
        />
        <Route path="contact" element={<Contact event={events} />} />
        <Route
          path="speakers"
          element={
            <ProtectedWrapper>
              <Speakers event={events} />
            </ProtectedWrapper>
          }
        />
        <Route path="gallery" element={<Gallery event={events} />} />
        <Route path="feedback" element={<Feedback event={events} />} />
        <Route path="checkIn/:id" element={<CheckIn event={events} />} />
        <Route path="signin" element={<SignIn event={events} />} />
      </Routes>
      {!hideFooter && <Footer event={events} />}
    </>
  );
}

export default EventLayout;
